module.exports = __webpack_public_path__ + "img/tiktok.2ba97507.svg";